<div class="Consult">
    <ul class="Consult_Toggle uk-child-width-1-2 uk-grid-collapse uk-grid" #switcher>
        <li>
			<div class="Consult_Toggle_Tab uk-position-relative">Уведомления
				<span class="Consult_Toggle_Counter" *ngIf="consultService.unreaded">{{consultService.unreaded}}</span>
			</div>
        </li>

		<li>
			<div class="Consult_Toggle_Tab uk-position-relative">Чат
				<div class="uk-modal-close-default" uk-toggle="target: #LeftMenu_Item_ConsultWindow">
					<span class="IconItem IconItem--close">
						<img src="/assets/img/icon/close.svg" uk-svg>
					</span>
				</div>
			</div>
		</li>
    </ul>

    <div class="uk-switcher">
        <div class="Consult_Messages">
            <div *ngFor="let notification of consultService.notifications; let i = index;">
                <div class="uk-text-center" *ngIf="showDate(i)">
                    <div class="Consult_Messages_Date">{{notification.createdAt|date:'d MMMM'}}</div>
                </div>
                <div class="Consult_Message"
					(mouseleave)="consultService.readNotification(notification)"
					[class.Consult_Message--unread]="!notification.isReaded"
				>
					<span class="Consult_Message_Text">{{notification.name}}</span>
					<span class="Consult_Message_Time">{{notification.createdAt|date:'HH:mm'}}</span>
					<button *ngFor="let btn of notification.buttons" [ngClass]="btn.ngclass"
							[attr.uk-toggle]="btn.customAttr.ukToggle" (click)="btn.click()">
						{{btn.text}}
					</button>

				</div>
            </div>
        </div>

	<div class="Consult_Chat uk-flex bx-livechat-chat-start" #chat>
		<div class="uk-margin-auto uk-margin-auto-vertical uk-spinner" uk-spinner="ratio: 3"></div>
	</div>
    </div>
</div>
